import { render, staticRenderFns } from "./POPaymentStatusBadge.vue?vue&type=template&id=7fe2580b&scoped=true"
import script from "./POPaymentStatusBadge.vue?vue&type=script&lang=ts"
export * from "./POPaymentStatusBadge.vue?vue&type=script&lang=ts"
import style0 from "./POPaymentStatusBadge.vue?vue&type=style&index=0&id=7fe2580b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe2580b",
  null
  
)

export default component.exports